import React, { useEffect, useState } from "react";
// import { useMediaQuery } from "react-responsive";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Cookies } from "react-cookie";
import axios from "axios";
import style from "css/my.module.css";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import ApplicationModal from "component/application/applicationModal";
import { closeAlert, openConfirm } from "../../redux/slices/alertSlice"; // openAlert 추가
import { deleteUserInfo } from "../../redux/slices/userSlice";
import { message } from "antd";
import LicenseQueueModal from "component/common/LicenseQueueModal";
import GuideModal from "component/application/guideModal";
import EditEmailModal from "component/application/editEmailModal";
import { useMediaQuery } from "react-responsive";

function My() {
  //dispatch
  const dispatch = useDispatch();

  //navigate
  const navigate = useNavigate();

  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  //payload
  const userPayload = useSelector((state) => state.user);

  const [appliedList, setAppliedList] = useState([]);
  const [availableList, setAvailableList] = useState([]);

  const [isOpenApplyModal, setIsOpenApplyModal] = useState(false);
  const [isOpenGuideModal, setIsOpenGuideModal] = useState(false);
  const [editEmailTarget, setEditEmailTarget] = useState(null);

  const [selectProduct, setSelectProduct] = useState({});
  // 상태: 'apply' (입력) -> 'queue' (대기) -> 'complete' (완료)
  const [applicationStatus, setApplicationStatus] = useState("apply");
  const [ticketInfo, setTicketInfo] = useState({ number: null, userId: null });

  const openApplyModal = (item) => {
    if (
      dayjs(item.START_DT).format("YYYY-MM-DD HH:mm") >
      dayjs().format("YYYY-MM-DD HH:mm")
    ) {
      message.warning("라이선스 신청 기간이 아닙니다.");
    } else {
      setSelectProduct(item);
      setIsOpenApplyModal(true);
    }
  };

  const openGuideModal = () => {
    setIsOpenGuideModal(true);
  };

  const closeApplyModal = () => {
    setSelectProduct({});
    setIsOpenApplyModal(false);
    setApplicationStatus("apply");
    setTicketInfo({ number: null, userId: null });
  };

  const closeGuideModal = () => {
    setIsOpenGuideModal(false);
  };

  const getAppliedList = () => {
    axios.get("/license/list/applied").then((res) => {
      if (res.status === 200) {
        setAppliedList(res.data?.list || []);
      }
    });
  };

  const getAvailableList = () => {
    axios.get("/license/list/available").then((res) => {
      if (res.status === 200) {
        setAvailableList(res.data?.list || []);
      }
    });
  };

  const refreshData = () => {
    getAppliedList();
    getAvailableList();
  };

  const logoutHandler = () => {
    axios.post("/user/logout").then((res) => {
      if (res.status === 200) {
        const authNm = process.env.REACT_APP_AUTH_TOKEN;
        const refreshNm = process.env.REACT_APP_REFRESH_TOKEN;
        const domain = process.env.REACT_APP_DOMAIN;
        const cookies = new Cookies();

        cookies.remove(authNm, { path: "/", domain: domain });
        cookies.remove(refreshNm, { path: "/", domain: domain });
        dispatch(deleteUserInfo());
        navigate(process.env.REACT_APP_CLIENT_URL);
      }
    });
  };

  const openDownloadUrl = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  useEffect(() => {
    getAppliedList();
    getAvailableList();
  }, []);

  const handleChangeStatus = (status, info = null) => {
    if (info) {
      setTicketInfo(info);
    }
    setApplicationStatus(status);
  };

  // [수정] 성공 시 처리 핸들러 (모달 닫기 + 새로고침 + 알림)
  const handleQueueSuccess = () => {
    // 1. 데이터 새로고침
    setApplicationStatus("complete");
    refreshData();
  };

  return (
    <div className={style.wrap}>
      <ApplicationModal
        product={selectProduct}
        open={isOpenApplyModal && applicationStatus !== "queue"}
        close={closeApplyModal}
        refresh={refreshData}
        setStatus={handleChangeStatus}
        status={applicationStatus}
      />

      <GuideModal
        open={isOpenGuideModal}
        close={closeGuideModal}
        campusCd={userPayload.campusCd}
      />

      <EditEmailModal
        open={editEmailTarget !== null}
        close={() => setEditEmailTarget(null)}
        applicationId={editEmailTarget?.APPLICATION_ID}
        email={editEmailTarget?.EMAIL}
        productNm={editEmailTarget?.PRODUCT_NM}
        refresh={refreshData}
      />

      {isOpenApplyModal && applicationStatus === "queue" && (
        <LicenseQueueModal
          isOverlay={true}
          logo={
            <>
              <img
                alt="product"
                src={`${process.env.REACT_APP_CLIENT_URL}img/product/adobe/${selectProduct.IMG_NM}`}
              />
              <p>{`${selectProduct.PRODUCT_NM}`}</p>
            </>
          }
          userId={ticketInfo.userId}
          ticketNumber={ticketInfo.number}
          onSuccess={handleQueueSuccess}
          onClose={closeApplyModal}
        />
      )}

      {/* ... 이하 기존 UI 코드 동일 ... */}
      <div className={style.header}>
        <img
          alt="logo"
          src={`${process.env.REACT_APP_CLIENT_URL}img/my/logo.png`}
        />
        <div className={style.header_info}>
          <span className={style.header_user_nm}>
            {userPayload.userNm + "님"}
          </span>
          <button
            type="button"
            className={style.btn_logout}
            onClick={() => {
              const obj = {
                title: "알림",
                content: "로그아웃 하시겠습니까?",
                submitEventHandler: () => {
                  logoutHandler();
                  dispatch(closeAlert());
                },
              };
              dispatch(openConfirm(obj));
            }}
          >
            <img
              alt="logout"
              src={`${process.env.REACT_APP_CLIENT_URL}img/my/logout.png`}
            />
          </button>
        </div>
      </div>
      <div className={style.body}>
        <div className={style.user_info_sidebar}>
          <div className={style.user_info}>
            <div className={style.user_nm}>
              {"안녕하세요,\n"}
              <span>{userPayload.userNm}</span>님
            </div>
            <div className={style.user_id}>
              {userPayload.userId}
              <br />
              {userPayload.email}
            </div>
          </div>
          <div className={style.contact_btn_group}>
            <button
              className={style.btn_guide}
              onClick={() => openGuideModal()}
            >
              <img
                alt="guide"
                src={`${process.env.REACT_APP_CLIENT_URL}img/my/guide.png`}
              />
              <span>Adobe 신청 후 활성화 방법</span>
            </button>
            {/* <button className={style.btn_inquiry}>
              <img
                alt="inquiry"
                src={`${process.env.REACT_APP_CLIENT_URL}img/my/inquiry.png`}
              />
              <span>1:1 문의</span>
            </button> */}
          </div>
        </div>
        <div className={style.applicaiton_container}>
          <div className={style.applicaiton_applied}>
            <div className={style.applicaiton_list_label}>Adobe 신청 목록</div>
            <div className={style.applicaiton_list_wrapper}>
              {appliedList.length > 0 ? (
                appliedList.map((item, index) =>
                  isMobile ? (
                    <div key={index} className={style.applicaiton_list_item}>
                      <div className={style.product_info}>
                        <img
                          alt="product"
                          src={`${process.env.REACT_APP_CLIENT_URL}img/product/adobe/${item.IMG_NM}`}
                        />
                        <span title={item.PERIOD_NM}>{item.PERIOD_NM}</span>
                        {item.STATUS === "CD0201" &&
                        item.DOWNLOAD_URL !== "" ? (
                          <button
                            className={style.product_download_btn}
                            onClick={() => openDownloadUrl(item.DOWNLOAD_URL)}
                          >
                            다운로드
                          </button>
                        ) : item.STATUS === "CD0202" ? (
                          <button
                            className={style.product_download_btn}
                            onClick={() => setEditEmailTarget(item)}
                          >
                            이메일 수정
                          </button>
                        ) : null}
                      </div>

                      {/* <div className={style.application_info}>
                        <div className={style.application_date_wrapper}>
                          <div className={style.application_date_label}>
                            신청일
                          </div>
                          <div className={style.application_date}>
                            {dayjs(item.APPLY_DT).format("YYYY-MM-DD")}
                          </div>
                        </div>
                        <div
                          className={`${style.status_info} ${
                            style[`${item.STATUS}`]
                          }`}
                        >
                          <span className={style.status_dot} />
                          <span>
                            {item.STATUS === "CD0202"
                              ? "승인 대기"
                              : item.STATUS === "CD0203"
                                ? "승인 보류"
                                : "승인 완료"}
                          </span>
                        </div>
                      </div> */}
                    </div>
                  ) : (
                    <div key={index} className={style.applicaiton_list_item}>
                      <div className={style.product_info}>
                        <img
                          alt="product"
                          src={`${process.env.REACT_APP_CLIENT_URL}img/product/adobe/${item.IMG_NM}`}
                        />
                        <span title={item.PERIOD_NM}>{item.PERIOD_NM}</span>
                        {item.STATUS === "CD0201" &&
                        item.DOWNLOAD_URL !== "" ? (
                          <button
                            className={style.product_download_btn}
                            onClick={() => openDownloadUrl(item.DOWNLOAD_URL)}
                          >
                            다운로드
                          </button>
                        ) : item.STATUS === "CD0202" ? (
                          <button
                            className={style.product_download_btn}
                            onClick={() => setEditEmailTarget(item)}
                          >
                            이메일 수정
                          </button>
                        ) : null}
                      </div>
                      <div className={style.application_info}>
                        <div className={style.application_date_wrapper}>
                          <div className={style.application_date_label}>
                            신청일
                          </div>
                          <div className={style.application_date}>
                            {dayjs(item.APPLY_DT).format("YYYY-MM-DD")}
                          </div>
                        </div>
                        <div
                          className={`${style.status_info} ${
                            style[`${item.STATUS}`]
                          }`}
                        >
                          <span className={style.status_dot} />
                          <span>
                            {item.STATUS === "CD0202"
                              ? "승인 대기"
                              : item.STATUS === "CD0203"
                                ? "승인 보류"
                                : "승인 완료"}
                          </span>
                        </div>
                      </div>
                    </div>
                  ),
                )
              ) : (
                <div className={style.empty_list_text}>
                  신청한 라이센스가 없습니다.
                </div>
              )}
            </div>
          </div>
          <div className={style.applicaiton_available}>
            <div className={style.applicaiton_list_label}>
              Adobe 신청 가능 목록
            </div>
            <div className={style.applicaiton_list_wrapper}>
              {availableList.length > 0 ? (
                availableList.map((item, index) => (
                  <div key={index} className={style.applicaiton_list_item}>
                    <div className={style.product_info}>
                      <img
                        alt="product"
                        src={`${process.env.REACT_APP_CLIENT_URL}img/product/adobe/${item.IMG_NM}`}
                      />
                      <span title={item.PERIOD_NM}>{item.PERIOD_NM}</span>
                    </div>
                    <div className={style.application_info}>
                      <div className={style.application_date_wrapper}>
                        <div className={style.application_date_label}>
                          신청기간
                        </div>
                        <div
                          className={style.application_date}
                          title={`${item.START_DT} ~ ${item.END_DT}`}
                        >
                          {dayjs(item.START_DT).format("YYYY-MM-DD HH:mm") +
                            " ~ " +
                            dayjs(item.END_DT).format("YYYY-MM-DD HH:mm")}
                        </div>
                      </div>

                      {item.LICENSE_CNT <= item.APPLIED_CNT ? (
                        <button
                          className={style.btn_application_disable}
                          disabled
                        >
                          <span>신청 마감</span>
                        </button>
                      ) : dayjs(item.START_DT).format("YYYY-MM-DD HH:mm") >
                        dayjs().format("YYYY-MM-DD HH:mm") ? (
                        <button
                          className={style.btn_application_disable}
                          disabled
                        >
                          <span>신청 예정</span>
                        </button>
                      ) : (
                        <button
                          className={style.btn_application}
                          onClick={() => openApplyModal(item)}
                        >
                          <span>신청</span>
                        </button>
                      )}
                    </div>
                  </div>
                ))
              ) : (
                <div className={style.empty_list_text}>
                  신청 가능한 라이센스가 없습니다.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default My;
